import { Component } from "@mna/react";
import { Trans } from "react-i18next";
import Modal from "react-modal";
import { commonConstant } from "../server/triage/constants";
import i18next from "../../src/i18n";

export default class ErrorModal extends Component {
  state = {};

  componentDidMount() {
    Modal.setAppElement("#root");
    this.props.setState({
      isLoading: false,
    });
  }

  closeModal = () => {
    this.props.clear();
    // this.setState({
    //   showModal: false,
    // })
  };

  render() {
    const {
      title,
      message,
      content,
      isOpen,
      clear,
      history,
      setState,
      comingFrom
    } = this.props;

    return (
      <>
        <Modal
          isOpen={isOpen}
          className="ReactModal__Content_triagepopup"
          overlayClassName="ReactModal__Overlay_triagepopup"
          role=""
        >
          <label className="confirm_title">
            {title}
          </label>
          <label>
            {message}
          </label>
          <div className="pop_button">
            <button
              aria-label={i18next.t("findcareoption.OK")}
              className="modal_yes"
              onClick={(e) => {
                setState({
                  isLoading: false,
                });
                this.props.clear();
                if (comingFrom !== commonConstant.orgSubscription && comingFrom !== commonConstant.PreLogin) {
                  if (sessionStorage.getItem("IsValidUser") == "true") {
                    history.push({
                      pathname: "/terms",
                      search: "?organizationId=" + localStorage.getItem("orgid"),
                    });
                  }
                   else if(sessionStorage.getItem("isTravelAid2")== "true"){
                    history.push({
                      pathname: "/triageNew",
                      search: "?organizationId=" + localStorage.getItem("orgid"),
                    });
                    }
                   else {
                    history.push("/terms");
                  }
                }else {
                  window.location.reload()
                }
              }}
            >
              <Trans i18nKey="findcareoption.OK">Ok</Trans>
            </button>
          </div>
        </Modal>
      </>
    );
  }
}
